import TenByTenVideosSlider from "./classes/TenByTenVideosSlider";
import TenByTenModal from "./classes/TenByTenModal";
import TenByTenAnimations from "./classes/TenByTenAnimations";

new TenByTenVideosSlider();
new TenByTenModal();
new TenByTenAnimations();
